import { IQueryParams } from '@/types'

class ClinicParamsMapper {
  toPersistence(domainData: IQueryParams) {
    return {
      idClinica: domainData?.clinicId,
      term: domainData?.term,
      nome: domainData?.name,
      tipoProfissional: domainData?.professionalType,
      idEspecialidade: domainData?.specialtyId,
      idPaciente: domainData?.patientId,
    }
  }
}

export default new ClinicParamsMapper()
